

const { REACT_APP_XEVAL_URI } = process.env;

const XEVAL_URI = REACT_APP_XEVAL_URI[REACT_APP_XEVAL_URI?.length - 1] === '/' ? REACT_APP_XEVAL_URI.slice(0, -1) : REACT_APP_XEVAL_URI;

export default {
    XEVAL_URI: XEVAL_URI,
}